import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-notfound',
    templateUrl: './app.notfound.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppNotfoundComponent {

}
